import { Injectable } from "@angular/core";
import { AbstractControl, UntypedFormArray, ValidationErrors, ValidatorFn } from "@angular/forms";
import _ from "lodash";

@Injectable({
	providedIn: "root",
})
export class CustomValidationService {
	constructor() {}

	duplicateValueValidator(): ValidatorFn {
		return (formArray: AbstractControl): ValidationErrors | null => {
			if (!(formArray instanceof UntypedFormArray)) {
				throw new Error("duplicateValueValidator: argument is not a FormArray");
			}

			const values = formArray.controls.map((control) => control.value);
			const hasDuplicate = values.some((value, index) => values.indexOf(value) !== index);

			return hasDuplicate ? { duplicate: true } : null;
		};
	}

	validateStaffId(control: AbstractControl): ValidationErrors | null {
		const value = (control.value ?? "").toString();
		const staffIds = control.parent?.parent?.value;
		const selectedStaffId = staffIds?.map((v: { staffNumber?: string }) => v.staffNumber) ?? [];
		const duplicates = selectedStaffId.filter(
			(v: string, index: number) => v != "" && selectedStaffId.indexOf(v) !== index,
		);

		if (!_.isEmpty(value) && value.length < 7) {
			return { minStaffIdlength: true };
		}

		if (!_.isEmpty(value) && value.length === 7) {
			if (duplicates.length > 0) {
				return { duplicateStaffId: true };
			}
			return null;
		}

		return null;
	}

	validateManeuver(control: AbstractControl): ValidationErrors | null {
		const value = control.value;
		const maneuver = control.parent?.parent?.value;
		const selectedManeuver = maneuver?.map((v: { maneuver?: { code?: string } }) => v.maneuver?.code);
		const duplicates = selectedManeuver?.filter(
			(maneuverCode: string, index: number) => selectedManeuver.indexOf(maneuverCode) !== index,
		);

		if (!_.isEmpty(value)) {
			if (duplicates.length > 0) {
				return { duplicateManevuer: true };
			}
		}
		return null;
	}

	allowOnlyNumbers(event: KeyboardEvent): void {
		const charCode = event.key.charCodeAt(0);
		if (charCode < 48 || charCode > 57) {
			event.preventDefault();
		}
	}

	validateSingleStaffId(control: AbstractControl): ValidationErrors | null {
		const value = (control.value ?? "").toString();

		if (!_.isEmpty(value) && value.length === 7) {
			return null;
		}

		return { minStaffIdlength: true };
	}
}
